import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  timeout: 30000 // 30 second timeout
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle response errors
// Routes that must keep rendering while the company is locked out, otherwise a
// 402 on one of their own calls would bounce the user off the page that fixes it.
const BILLING_SAFE_PATHS = ['/admin/billing', '/subscription-required', '/support', '/login'];

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    // 402 = pricing enforcement is on and this company has no active plan.
    if (error.response?.status === 402) {
      const path = window.location.pathname;
      const onSafePage = BILLING_SAFE_PATHS.some((p) => path.startsWith(p));
      // Seat-limit rejections are also 402 but are a form validation result,
      // not a lockout — let the calling page show the message.
      const isLockout = error.response?.data?.code === 'subscription_required';
      if (isLockout && !onSafePage) {
        window.location.href = '/subscription-required';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
